var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-footer w-100 d-flex justify-content-between p-3"},[_c('small',[_vm._v("Copyright 2019 Refined K-9 | "),_c('a',{attrs:{"href":"/privacy"}},[_vm._v("Privacy Policy")])]),_vm._v(" "),_c('small',{staticClass:"text-right"},[_vm._v("Made with ❤ in San Francisco")])])
}]

export { render, staticRenderFns }